export const GET_PRODUCT_SLIP_LIST_REQUEST = "get_product_slip_list_request";
export const GET_PRODUCT_SLIP_LIST_RESPONSE = "get_product_slip_list_response";

export const UPDATE_PRODUCT_SLIP_STATUS_BY_PRODUCT_SLIP_ID_REQUEST =
  "update_product_slip_status_by_product_slip_id_request";
export const UPDATE_PRODUCT_SLIP_STATUS_BY_PRODUCT_SLIP_ID_RESPONSE =
  "update_product_slip_status_by_product_slip_id_response";
